import { useState } from 'react';
import { useDevedor } from '../../../context/ConsultContext';
import { useInvoicesTable } from '../../../context/TableContext';
import { useLoading } from '../../../hooks/useLoading';
import { api } from '../../../services/api';
import { InputDateMask } from '../../Inputs/InputDateMask/InputDateMask';
import { Loader } from '../../Loader/Loader';
import {
  ContainerBackground,
  Container,
  ModalContainer,
  ModalBody,
  InputBlock,
  Button,
} from '../styles';

export const CashModal = () => {
  const {
    openCashModal,
    idParcela,
    faturaParcela,
    page,
    listarFaturas,
    setTableSelected,
    setMudarFaturaParcela,
  } = useInvoicesTable();

  const { cpf, devedor } = useDevedor();
  const { showLoader, hideLoader, loader } = useLoading();

  const [valor, setValor] = useState('');
  const [pagamento, setPagamento] = useState('');
  const [text, setText] = useState('');

  const parcela = faturaParcela.parcelas.find(
    (parcela) => parcela.nroparc === idParcela.nroparc,
  );

  async function handleSubmit(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) {
    e.preventDefault();

    if (valor === '' && pagamento === '') {
      openCashModal();
      return;
    }

    if (valor === '' || pagamento === '') {
      setText('Preencha todos os campos');
      return;
    }

    if (page === 'register') {
      const index = faturaParcela.parcelas.findIndex(
        (parcela) =>
          parcela.nroparc === idParcela.nroparc &&
          parcela.documento === idParcela.documento,
      );

      const valorParc = valor.replace(',', '.');

      faturaParcela.parcelas[index].valorPago = Number(valorParc);
      faturaParcela.parcelas[index].pagamento = pagamento
        .split('/')
        .reverse()
        .join('-');

      setMudarFaturaParcela(faturaParcela);
    } else {
      const parcela = faturaParcela.parcelas.find(
        (parcela) => parcela.nroparc === idParcela.nroparc,
      );

      showLoader();

      const valorParc = valor.includes(',') ? valor.replace(',', '.') : valor;

      const response = await api.put(`/parcela/update/pagamento`, {
        documento: idParcela.documento,
        nroparc: idParcela.nroparc,
        cpf,
        valor: Number(valorParc),
        pagamento: pagamento.split('/').reverse().join('-'),
        uf: devedor?.uf,
        tipodoc: faturaParcela.fatura.tipodoc,
        credor: '685',
        valorFatura: faturaParcela.fatura.valorfatura,
        vencimento: parcela?.vencimento,
      });

      listarFaturas(response.data.faturas_parc);
      setTableSelected(response.data.documento);
    }
    hideLoader();
    openCashModal();
  }

  return (
    <ContainerBackground>
      <Container>
        <ModalContainer>
          <span>{text}</span>
          <ModalBody>
            <form>
              <InputBlock>
                <label>Valor pago</label>
                <input
                  type="text"
                  placeholder={`${parcela?.valorparc}`}
                  onChange={(e) => setValor(e.target.value)}
                />
              </InputBlock>

              <InputBlock>
                <label>Data de Pagamento</label>
                <InputDateMask
                  type="text"
                  name="pagamento"
                  placeholder={parcela?.vencimento
                    .split('-')
                    .reverse()
                    .join('/')}
                  onChange={(e) => setPagamento(e.target.value)}
                />
              </InputBlock>

              <Button type="button" onClick={(e) => handleSubmit(e)}>
                Confirmar
              </Button>
            </form>
          </ModalBody>
        </ModalContainer>
      </Container>
      {loader && <Loader />}
    </ContainerBackground>
  );
};
